import accessoriesOptions from '@/ui/ui_accessories/default-selectors.json';

/**
 * @module getProductAccessoriesData
 *
 * @description
 * Получение данных об аксессуарах из ноды товара
 * @param {HTMLElement} productNode - узел товара
 *
 * @return {Object} - объект с данными об аксессуарах
 */
export default (productNode) => {
  const accessoriesData = {};

  if (!productNode) { return accessoriesData; }

  const accessoriesItemNodes =
    productNode.querySelectorAll(`${accessoriesOptions.accessoryValuesItem.attr} input:checked`);

  for (const accessoriesItemNode of accessoriesItemNodes) {
    accessoriesData[accessoriesItemNode.value] = 1;
  }

  return accessoriesData;
};
